import {
  GET_AUTO_REPORT_DATA,
  GET_AUTO_REPORT_FIELD,
  getAutoReportField,
  getAutoReportValue,
} from 'src/clients';
import useSWR from 'swr';

export const useAutoReportFormData = (product_name?: string) => {
  const { data, ...swr } = useSWR(
    product_name
      ? [`${GET_AUTO_REPORT_FIELD}?product_name`, product_name]
      : null,
    () => getAutoReportField(product_name ?? '').then(res => res.data.data),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return { data, ...swr };
};

export const useAutoReportFormDataConfig = (
  isEditConfig: boolean,
  product_name?: string,
) => {
  const { data, ...swr } = useSWR(
    product_name && isEditConfig
      ? [`${GET_AUTO_REPORT_DATA}?product_name`, product_name]
      : null,
    () => getAutoReportValue(product_name ?? '').then(res => res.data.data),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return { data, ...swr };
};
